<div class="form-group">
  <label class="control-label" ng-if="showTitle()">{{showTitle()}}</label>
  <select-box model="$$value$$" config="form.config" value-field="{{form.valueField}}" display-field="{{form.displayField}}"></select-box>
</div>